"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.errors.stepsLoadFailed': 'Impossibile caricare i passi',
    'tutorial.errors.avatarsLoadFailed': 'Impossibile caricare gli avatar',
    'tutorial.errors.companiesLoadFailed': 'Impossibile caricare le aziende',
    'tutorial.errors.loadFailed': 'Impossibile caricare il tutorial',
};
